const TONE_CLASSES: Record<string, string> = {
  neutral: "bg-background-100 text-foreground-600",
  info: "bg-blue-100 text-blue-700",
  success: "bg-green-100 text-green-700",
  warning: "bg-caution-100 text-caution-700",
  danger: "bg-danger-100 text-danger-700",
};

function Pill({ label, tone }: { label: string; tone: keyof typeof TONE_CLASSES }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${TONE_CLASSES[tone]}`}>
      {label}
    </span>
  );
}

const PROCESSING_STATUS_LABELS: Record<string, { label: string; tone: keyof typeof TONE_CLASSES }> = {
  IMAGE_RECEIVED: { label: "Imagem recebida", tone: "neutral" },
  ANALYZED_BY_CHATGPT: { label: "Analisada (IA)", tone: "info" },
  JSON_READY: { label: "JSON pronto", tone: "info" },
  SENT_TO_CODEX: { label: "Enviada ao Codex", tone: "info" },
  IMPORTED: { label: "Importada", tone: "info" },
  PERSISTED_IN_DATABASE: { label: "Persistida", tone: "info" },
  VALIDATED_IN_FIELD: { label: "Validada em campo", tone: "success" },
  APPROVED: { label: "Aprovada", tone: "success" },
};

export function ProcessingStatusBadge({ status }: { status: string }) {
  const entry = PROCESSING_STATUS_LABELS[status] ?? { label: status, tone: "neutral" as const };
  return <Pill label={entry.label} tone={entry.tone} />;
}

const FIELD_VALIDATION_STATUS_LABELS: Record<string, { label: string; tone: keyof typeof TONE_CLASSES }> = {
  PENDENTE: { label: "Validação pendente", tone: "warning" },
  EM_ANDAMENTO: { label: "Validação em andamento", tone: "info" },
  CONCLUIDA: { label: "Validada em campo", tone: "success" },
  CONCLUIDO: { label: "Validada em campo", tone: "success" },
};

export function FieldValidationStatusBadge({ status }: { status: string }) {
  const entry = FIELD_VALIDATION_STATUS_LABELS[status] ?? { label: status, tone: "neutral" as const };
  return <Pill label={entry.label} tone={entry.tone} />;
}

const PRIORITY_LABELS: Record<string, { label: string; tone: keyof typeof TONE_CLASSES }> = {
  CRITICA: { label: "Crítica", tone: "danger" },
  CRITICAL: { label: "Crítica", tone: "danger" },
  ALTA: { label: "Alta", tone: "danger" },
  HIGH: { label: "Alta", tone: "danger" },
  MEDIA: { label: "Média", tone: "warning" },
  MEDIUM: { label: "Média", tone: "warning" },
  BAIXA: { label: "Baixa", tone: "success" },
  LOW: { label: "Baixa", tone: "success" },
};

export function PriorityBadge({ priority }: { priority: string }) {
  const entry = PRIORITY_LABELS[priority] ?? { label: priority, tone: "neutral" as const };
  return <Pill label={entry.label} tone={entry.tone} />;
}

export function ConfidenceBadge({ score }: { score: number | null }) {
  if (score === null) return <Pill label="Confiança desconhecida" tone="neutral" />;
  if (score >= 0.75) return <Pill label={`Confiança alta (${Math.round(score * 100)}%)`} tone="success" />;
  if (score >= 0.45) return <Pill label={`Confiança média (${Math.round(score * 100)}%)`} tone="warning" />;
  return <Pill label={`Confiança baixa (${Math.round(score * 100)}%)`} tone="danger" />;
}

export function GenericStatusBadge({ status }: { status: string }) {
  return <Pill label={status} tone="neutral" />;
}
